import { css } from 'lit';
export default css `
    :host {
        display: flex;
        position: relative;
        flex-flow: column;
    }

    :host(:not([is-overflow])) {
        align-items: center;
        justify-content: center;
    }

    :host(:not([level='1'])) {
        white-space: normal;
    }

    :host([level='1']) {
        white-space: nowrap;
    }

    .nav-item {
        list-style: none;
    }

    /**
     * Nav links
     */

    /* Bottom navigation mobile */
    :host([form-factor='mobile']:not([is-overflow])) .nav-link {
        flex-direction: column;
        gap: var(--spacing-xs);
    }

    :host([form-factor='mobile'][level='1']:not([is-overflow])) .nav-link {
        gap: var(--spacing-xxs);
    }

    :host([form-factor='tablet']) .nav-link,
    :host([form-factor='desktop']) .nav-link {
        position: relative;
    }

    /* Active state */
    :host([form-factor='tablet'][is-active]:not([level='1'])) .nav-link-text::after,
    :host([form-factor='desktop'][is-active]:not([level='1'])) .nav-link-text::after,
    :host([is-active][is-overflow]:not([level='1'])) .nav-link-text::after {
        content: '';
        position: absolute;
        height: var(--spacing-xxxs);
        background-color: var(--color-secondary);
    }

    :host([is-active][is-overflow]) .nav-link-text::after {
        left: 0;
        right: 0;
        bottom: var(--spacing-neg-xxs);
    }

    :host([form-factor='tablet'][is-active]:not([is-overflow])) .nav-link-text::after,
    :host([form-factor='desktop'][is-active]:not([is-overflow])) .nav-link-text::after {
        left: var(--spacing-m);
        right: var(--spacing-m);
        bottom: 0;
    }

    :host([form-factor='mobile'][is-primary-overflow]:not([is-expanded])) .nav-link {
        --color: var(--color-text);
        --icon-color: var(--color-text);
    }

    :host([type='context-switch'][is-active]) .nav-link-text::after {
        content: none;
    }

    .context-switch-active-icon {
        margin-inline-start: var(--spacing-xs);
    }

    /*  */
    :host([is-overflow][level='1']) {
        gap: var(--spacing-xs);
    }

    .nav-link {
        display: flex;
        align-items: center;
        color: var(--color-primary);
        padding-block-start: var(--spacing-s);
        padding-block-end: var(--spacing-s);
        text-decoration: none;
    }

    :host([form-factor='mobile'][level='1']:not([is-overflow])) .nav-link {
        --color: var(--color-text);
        --icon-color: var(--color-text);
    }

    :host([is-overflow]) .nav-link:not([href]) {
        --color: var(--color-text);
        --icon-color: var(--color-text);
    }

    :host([form-factor='mobile'][is-active]:not([is-overflow])) .nav-link {
        --color: var(--color-primary);
        --icon-color: var(--color-primary);

        cursor: pointer;
    }

    :host([form-factor='tablet']) .nav-link,
    :host([form-factor='desktop']) .nav-link,
    :host([is-overflow]) .nav-link {
        padding: var(--spacing-m);
    }

    :host([is-overflow]) > .nav-item > .nav-link {
        gap: var(--spacing-m);
    }

    :host(:not([is-overflow])) > .nav-item .nav-link {
        gap: var(--spacing-xs);
    }

    :host([is-overflow]) .nav-link[href]:hover,
    :host([is-overflow]) .nav-link[href]:focus,
    :host([is-overflow]) .nav-link[href]:active {
        background-color: var(--color-ui-07);
        border-radius: var(--radius-m);
    }

    :host([is-overflow]) .nav-link-text {
        position: relative;
    }

    /**
     * Disclosure menu triggers
     */

    .disclosure-trigger-icon {
        display: flex;
        align-items: center;
        transition: transform var(--transition-speed) var(--ease-in-out-quart);
        margin-inline-start: auto;
    }

    .nav-link[aria-expanded='true'] .disclosure-trigger-icon {
        transform: rotate(-180deg);
    }

    :host([form-factor='tablet']) .disclosure-trigger-icon,
    :host([form-factor='desktop']) .disclosure-trigger-icon {
        --icon-width: var(--spacing-s);
    }

    /**
     * Menus
     */

    .menu {
        margin: 0;
        padding: 0;
        transition: all var(--transition-speed-slow) var(--ease-in-out-quart);
    }

    /**
     * Overflow menus
     */

    .overflow-menu-wrapper {
        transition: all var(--transition-speed-slow) var(--ease-in-out-quart);
    }

    :host([form-factor='mobile']) .overflow-menu-wrapper {
        --surface-border-radius: 0;

        position: fixed;
        left: 0;
        right: 0;
    }

    :host([form-factor='mobile'][animation-direction='top-to-bottom']) .overflow-menu-wrapper {
        top: 0;
    }

    :host([form-factor='mobile'][animation-direction='bottom-to-top']) .overflow-menu-wrapper {
        top: 100%;
    }

    :host([form-factor='tablet']) .overflow-menu-wrapper,
    :host([form-factor='desktop']) .overflow-menu-wrapper {
        width: 22rem;
    }

    .overflow-menu-wrapper:not([is-open]) {
        pointer-events: none;
        max-height: 0;
        opacity: 0;
    }

    .overflow-menu-wrapper[is-open] {
        opacity: 1;
    }

    :host([form-factor='mobile']) .overflow-menu-wrapper[is-open] {
        max-height: 100vh;
    }

    :host([form-factor='mobile'][animation-direction='bottom-to-top']) .overflow-menu-wrapper[is-open] {
        top: 0;
    }

    :host([form-factor='tablet']) .overflow-menu-wrapper[is-open],
    :host([form-factor='desktop']) .overflow-menu-wrapper[is-open] {
        max-height: 40rem;
    }

    .overflow-menu-inner {
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: flex-end;
    }

    .overflow-menu {
        margin: 0;
        padding: 0;
        list-style: none;
        overflow-y: auto;
        margin-block-start: auto;
    }

    .overflow-menu > .nav-item,
    .context-switch-menu {
        padding: var(--spacing-xxs);
    }

    :host([form-factor='mobile']) .overflow-menu > .nav-item:first-child,
    .overflow-menu > .nav-item[level='1'] + .nav-item[level='1'],
    .context-switch-menu {
        border-top: 1px solid var(--color-ui-06);
    }

    :host([form-factor='mobile']) .overflow-menu-wrapper {
        bottom: var(--bottom-navigation-height, 0);
    }
`;
